import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, reactive } from 'vue';
    import { useStore } from 'vuex';
    import { ElMessage } from 'element-plus';
    import type { FormInstance, FormRules } from 'element-plus'
    import Api from '@/services/api'
    import { User } from '@/services/types'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

    const store = useStore();

    const loading = ref<boolean>(false)

    const loginForm = ref<FormInstance>()
    const rules = reactive<FormRules<User>>({
        phone: [
            { required: true, message: 'Por favor insira o numero de telefone', trigger: 'blur'},
        ],
        password: [
            { required: true, message: 'Por favor digite a senha', trigger: 'blur'},
        ],
    })
    const user = reactive<User>({
        phone: null,
        password: '',
    })
    const handleLogin = async (formEl: FormInstance | undefined) => {
        if (!formEl) { return }
        await formEl.validate(async (valid) => {
            if (valid) {
                loading.value = true
                console.log(user)
                const res = await Api.post("/auth/login", {
                    phone: user.phone,
                    password: user.password
                })
                console.log(res)
                if ((res.status >= 200 && res.status < 300) && (res.data.user.role == 'admin' || res.data.user.role == 'master')) {

                    store.dispatch('login', res.data.token)
                    sessionStorage.setItem("user", JSON.stringify(res.data.user))
                    window.location.href = "/home"
                } else if (res.status == 422) {
                    if (res.data.errors) {
                        const erros = res.data.errors
                        loginForm.value?.fields.forEach((val) => {
                            Object.keys(erros).forEach(field => {
                                if (val.prop == field) {
                                    val.validateState = "error"
                                    ElMessage({
                                        type: "error",
                                        message: res.data.errors[field][0]
                                    })
                                }
                            })
                        })
                    }
                } else {
                    ElMessage({
                        type: "error",
                        message: "Ocorreu um erro ao tentar iniciar sessão"
                    })
                }
                loading.value = false
            } else {
                ElMessage.error({
                    message: "Por favor preencha corretamente"
                })
            }
        })
    }

return (_ctx: any,_cache: any) => {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    ref_key: "loginForm",
    ref: loginForm,
    rules: rules,
    model: user,
    class: "login-form",
    "label-position": "top",
    size: "large"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_header, { class: "text-center h2 py-3" }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
          _createTextVNode(" Iniciar sessão ", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "Insira seu teefone",
        prop: "phone"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            type: "number",
            min: 820000000,
            max: 879999999,
            step: 1,
            modelValue: user.phone,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((user.phone) = $event)),
            placeholder: "Celular",
            "prefix-icon": "Phone"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "Insira sua senha",
        prop: "password"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: user.password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((user.password) = $event)),
            type: "password",
            placeholder: "Senha",
            "prefix-icon": "Lock",
            "show-password": ""
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, {
            type: "primary",
            class: "login-button col-12 col-md-auto m-1",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (handleLogin(loginForm.value))),
            loading: loading.value
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode("Entrar", -1)
            ]))]),
            _: 1
          }, 8, ["loading"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["rules", "model"]))
}
}

})